import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRegistry } from 'react-native';
import App from './App';
import './index.css';

/**
 * React Native for Web bootstrap.
 *
 * The app is registered with `AppRegistry` — the React Native entry point — and
 * run into the DOM host. This keeps the RN application contract intact while
 * rendering through react-native-web.
 */
AppRegistry.registerComponent('L48Dashboard', () => App);

const container = document.getElementById('root');
if (!container) throw new Error('Root container not found');

// react-native-web injects its base stylesheet when the app is registered;
// rendering through createRoot keeps React 18 concurrent features available.
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
